import React from 'react';
import ChannelFormModal from '../ChannelFormModal';

const EditChannelModal = ({
  visible,
  channel,
  onClose,
  onSubmit,
}) => {
  return (
    <ChannelFormModal
      visible={visible}
      title="Editar canal"
      submitLabel="Salvar"
      initialValue={channel}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default EditChannelModal;
